import { render, staticRenderFns } from "./SchoolClassSetup.vue?vue&type=template&id=21dadb70&"
import script from "./SchoolClassSetup.vue?vue&type=script&lang=js&"
export * from "./SchoolClassSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports